import { Injectable } from '@angular/core';
import { BaseHttpClient } from '@peca/commons';
import { Pageable } from '@peca/backoffice/models/pageable.model';
import { environment } from 'apps/backoffice/src/environments/environment';

import { CreateRegionRequest, RegionResponse } from '../types/region.type';
import { RegionQuery } from '../types/region-query.type';

@Injectable({ providedIn: 'root' })
export class RegionsService extends BaseHttpClient {
  private readonly resource = `${environment.gateway.url}/backoffice/v1/regions`;

  list(query: RegionQuery) {
    const params = this.prepareQuery(query);
    return this.http.get<Pageable<RegionResponse>>(this.resource, { params });
  }

  create(payload: CreateRegionRequest) {
    return this.http.post<RegionResponse>(this.resource, payload);
  }

  getById(id: number | string) {
    return this.http.get<RegionResponse>(`${this.resource}/${id}`);
  }

  delete(id: number | string) {
    return this.http.delete<void>(`${this.resource}/${id}`);
  }

  suggest(search: string) {
    return this.http.get<RegionResponse[]>(`${this.resource}/suggestions`, { params: { search } });
  }
}
